module.exports = __webpack_public_path__ + "static/sonia-report-tc-f44b36e5b015cecbbcc303c6687ee11d.png";